import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs';
import { ConfirmationDialogComponent } from '../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private dialogRef!: any;
  private currentVersion: string = '';
  tempVersion!: string;
  isModalOpen!: boolean;

  constructor(
    private _http: HttpClient,
    private _dialog: MatDialog,
    private _spinner: NgxSpinnerService
  ) {}

  initVersionCheck(intervalMs: number = 300000) {
    if (this.isLocalhost()) {
      console.log('[VersionCheck] Skipped on localhost.');
      return;
    }

    // Initial check
    this.checkVersion();

    // Set up periodic checks
    interval(intervalMs).subscribe(() => {
      this.checkVersion();
    });
  }

  private checkVersion(): void {
    this._http
      .get<{
        version: string;
      }>(`/assets/version.json?v=${Date.now()}`, {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe({
        next: res => {
          const newVersion = res.version;
          if (this.currentVersion && this.currentVersion !== newVersion) {
            this.tempVersion = newVersion; // Update current version
            if (!this.isModalOpen) this.confirmationModel();
          } else this.currentVersion = newVersion; // Set initial version
        },
        error: () => {
          console.error('Could not fetch version.json');
        },
      });
  }

  private isLocalhost(): boolean {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname.startsWith('127.')
    );
  }

  private confirmationModel() {
    this.isModalOpen = true;
    this.dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      width: '23.472vw',
      // height: '161px',
      data: {
        header: 'Update ?',
        data: {
          bodyData: `New version of the app is available you want to update ?`,
        },
        button: {
          isSubmit: true,
          submitbtnText: 'Update',
          isCancel: true,
          isDelete: false,
        },
      },
    });
    this.dialogRef.disableClose = true;

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.isModalOpen = false;
      if (result == 'ok') {
        this._spinner.show();
        setTimeout(() => {
          this.currentVersion = this.tempVersion;
          // window.location.href = window.location.href;
          // window.location.reload();
          // location.reload(); // Refresh the app
          const url = new URL(window.location.href);
          url.searchParams.set('v', Date.now().toString());
          location.href = url.toString();
          // location.href = location.href.split('?')[0] + '?v=' + Date.now();
        }, 0);
      }
    });
  }
}
